import axios from "axios";
const API = process.env.REACT_APP_API_URL || "/api";

function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function getAdminDashboard() {
  try {
    const res = await axios.get(API + "/admin/dashboard", { headers: getAuthHeaders() });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function getAdminUsers(params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(API + "/admin/users?" + query, { headers: getAuthHeaders() });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function updateAdminUserMember(id, data) {
  try {
    const res = await axios.post(API + "/admin/users/" + id + "/member", data, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function generateAdminCodes(data) {
  try {
    const res = await axios.post(API + "/admin/codes", data, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function getAdminCodes(params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(API + "/admin/codes?" + query, { headers: getAuthHeaders() });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function revokeAdminCode(id) {
  try {
    const res = await axios.post(API + "/admin/codes/" + id + "/revoke", {}, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function getAdminPeople(params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(API + "/admin/people?" + query, { headers: getAuthHeaders() });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function deleteAdminCodes(ids) {
  try {
    const res = await axios.post(
      API + "/admin/codes/delete",
      { ids },
      { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
    );
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function deleteAdminUsers(ids) {
  try {
    const res = await axios.post(
      API + "/admin/users/delete",
      { ids },
      { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
    );
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

async function getAdminLogs(params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const res = await axios.get(API + "/admin/logs?" + query, { headers: getAuthHeaders() });
    if (res.status >= 200 && res.status < 300) return res.data;
  } catch (err) {
    if (err.response?.data) return err.response.data;
    console.log(err);
  }
  return null;
}

export {
  getAdminDashboard,
  getAdminUsers,
  updateAdminUserMember,
  generateAdminCodes,
  getAdminCodes,
  revokeAdminCode,
  deleteAdminCodes,
  deleteAdminUsers,
  getAdminPeople,
  getAdminLogs,
};
